// 📦 src/utils/top16.js

export const TOP16_HANDLES = [
  "dashtop-multi-mount-dmm",
  "billet-aluminum-4th-gen-tacoma-6th-gen-4runner-dmm",
  // ... other top product handles here ...
  
  // 👇 Put Gift Card + Certificate LAST
  "gift-card", 
  "the-taco-garage-gift-certificate", 
];

export const TOP16_TITLE_MATCHES = [
  "Dashtop Multi Mount (DMM)",
  "Billet Aluminum 4th Gen Tacoma / 6th Gen 4runner Dashtop Multi Mount (DMM)",
  "Custom Light-Up (DRL) Covers for Baja Designs XL Sport / Pro / XL80 Pods",
  "2005-Current Toyota Tacoma King 2.5 Remote Reservoir Coilover Kit",
  "Dirtking Tubular Ball Joint Upper Control Arms UCA, 2005+ Tacoma 2/4WD",
  "Bilstein 6112 Series Front and Rear Shock Kit for 2005 - 2023 Toyota Tacoma",
  "XL Linkable LED Light Bar - Universal",
  "2nd and 3rd Gen Toyota Tacoma Prinsu Top Rack | 2005 - 2020",
  "Baja Designs Squadron Sport LED Light Pods",
  "Baja Designs S2 Sport LED Light Pods",
  "AR-800 RGB Switch Panel with APP with support for Toggle/ Momentary/ Pulsed Modes",
  "Baja Designs Squadron LED Lights and fog Mounts (2012 - 2023 Tacoma)",
  "Baja Designs LP4 Pro with Amber DRL",
  "Billet Strut Reinforcement Plate Spacer with 1\" Lift for 4th Gen Toyota Tacoma 2024+ (Pair)",
  "Custom Light-Up (DRL) Covers for Baja Designs Squadron Sport / Pro Pods",
  "THE GUARDIAN\" Leveling Kit / Shock reinforcement for 4th Gen Toyota Tacoma 2024+ (Pair)",

  // 👇 Put Gift Card + Certificate LAST
  "Gift Card",
  "The Taco Garage Gift Certificate",
];
